import React from "react";
import classNames from "classnames";
import { KatButton, KatIcon } from "@amzn/katal-react";
import { useTranslation } from "react-i18next";
import { useValidationResults } from "src/components/Contexts/ValidationResultsContext";
import { useDocumentCompliance } from "src/components/Contexts/DocumentComplianceContext";

import { useDocumentComplianceHelper } from "./DocumentComplianceHelperContext";
import styles from "./styles.module.scss";
import publishMetric, { MetricAction } from "src/metrics";
import { extractAllValidationResults } from "./document-compliance-helper-extractor";

const DocumentComplianceHelperButton: React.FC = () => {
  const { t } = useTranslation();
  const { setVisible } = useDocumentComplianceHelper();

  const documentCompliance = useDocumentCompliance();
  const { validationResultsByGroup } = useValidationResults();
  const groupedValidationResults = extractAllValidationResults(
    validationResultsByGroup,
    documentCompliance,
    t
  );

  const hasResults = (): boolean => {
    return (
      groupedValidationResults &&
      Object.keys(groupedValidationResults).length > 0 &&
      Object.values(groupedValidationResults).flat().length > 0
    );
  };

  const handleOpenHelper = () => {
    publishMetric(MetricAction.COMPLIANCE_HELPER_PANEL_OPENING);
    setVisible(true);
  };

  return (
    <div className={classNames(styles.helper_button)}>
      <div
        title={
          !hasResults()
            ? t("aic_doc_page_inbound_document_compliance_helper_title_error")
            : t("aic_doc_page_inbound_document_compliance_helper_title")
        }
      >
        <KatButton
          variant="tertiary"
          size="base"
          onClick={() => handleOpenHelper()}
          disabled={!hasResults()}
        >
          <KatIcon name="info-circle" size="small" />
          {"   "} {t("aic_doc_page_inbound_document_compliance_helper_title")}
        </KatButton>
      </div>
    </div>
  );
};

export default DocumentComplianceHelperButton;
